// extracted by mini-css-extract-plugin
export var layout = "dc_cc";